// extracted by mini-css-extract-plugin
export default {"tabsList":"mbA8G4tznYL8RHgr0B99"};